import { useSyncExternalStore } from 'react'

import {
  getAuthSession,
  getAuthSessionRevision,
  subscribeAuthSession,
} from '../services/authSession'

function useAuthSessionRevision() {
  return useSyncExternalStore(
    subscribeAuthSession,
    getAuthSessionRevision,
    getAuthSessionRevision,
  )
}

function useAuthSession() {
  useAuthSessionRevision()
  return getAuthSession()
}

export { useAuthSessionRevision }
export default useAuthSession
